export default [
  { label: 'JANEIRO',   value: 0 },
  { label: 'FEVEREIRO', value: 1 },
  { label: 'MARÇO',     value: 2 },
  { label: 'ABRIL',     value: 3 },
  { label: 'MAIO',      value: 4 },
  { label: 'JUNHO',     value: 5 },
  { label: 'JULHO',     value: 6 },
  { label: 'AGOSTO',    value: 7 },
  { label: 'SETEMBRO',  value: 8 },
  { label: 'OUTUBRO',   value: 9 },
  { label: 'NOVEMBRO',  value: 10 },
  { label: 'DEZEMBRO',  value: 11 }
]